export default __webpack_public_path__ + "static/media/AE.b5981536.svg";